import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { PaymentReconciliation } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/payment-reconciliation")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <PaymentReconciliation />
    </RouteGuard>
  ),
});
